/* global eggoShipping */
/* global Shopify */


export class EggoCartShipping {
    /** totalCartValue is the cart total after discounts, in major units (e.g. 49.9). */
    constructor(totalCartValue, eggoCart) {
        this.eggoCart = eggoCart;
        this.meterElement = this.eggoCart.querySelector(".cart-drawer__inner-real .cart-drawer__shipping-meter-value");
        this.messageElement = this.eggoCart.querySelector(".cart-drawer__inner-real .cart-drawer__shipping-message-text");
        if (!this.meterElement || !this.messageElement || typeof eggoShipping === "undefined") return;
        this.width = "0%";
        this.message = "";
        if(totalCartValue >= eggoShipping.limit){
            this.width = "100";
            this.message = eggoShipping.messageFreeShipping;
        }
        else{
            this.width = (100 * totalCartValue / eggoShipping.limit);
            this.message = eggoShipping.messageLeft.replace("[value]", Shopify.formatMoney(Math.round(eggoShipping.limit*100 - totalCartValue*100)));
        }

        this.meterElement.style.width = this.width + "%";
        this.messageElement.innerHTML = this.message;
    }
}
